module.exports = __webpack_public_path__ + "img/c3.4d424e11.jpg";